import React, {Component} from 'react';
import axios from 'axios';
import {browserHistory} from 'react-router'
import { BASE_URL } from './constants/api';

class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        this.onBtnClickHandler = this.onBtnClickHandler.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.back = this.back.bind(this);
        this.state = {
            email: ''
        }
    }

    onFieldChange(e) {
        this.setState({email: e.target.value})
    }

    back(){
        browserHistory.push(`/StepOne`)
    }

    onBtnClickHandler(e) {
        e.preventDefault()
        if (this.state.email.length > 0) {
            axios.post(`${BASE_URL}/api/v1/restore_password`, {
                    email: this.state.email
                },
            ).then(function () {
                browserHistory.push(`/StepOne`)
            }).catch(function (error) {
                if (error.response.data.type == "Unauthorized") {
                    localStorage.removeItem("servicesData");
                    localStorage.removeItem("appointment_details");
                    localStorage.removeItem("appointment");
                    localStorage.removeItem("services");
                    localStorage.removeItem("user");
                    alert(error.response.data.type);
                    browserHistory.push(`/StepOne`)
                } else {
                    alert(error.response.data.message);
                }
            });
        }
    }

    render() {
        return (
            <div classNameName="smart-wrap">
                <div className="smart-forms smart-container wrap-2">
                    <div className="form-header header-lite">
                        <h4>Forgot Password</h4>
                    </div>
                    <div className="form-body smart-steps steps-theme-primary">
                        <form method="post" action="#" id="smart-form">
                            <fieldset>
                                <h3 className="subtitle">Enter your e-mail address and we will send you a link to reset
                                    your password.</h3>
                                <div id="ctr_personal" className="hiddenbox">
                                    <div className="section">
                                        <label for="email" className="field-label">Your email address</label>
                                        <label className="field prepend-icon">
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="gui-input"
                                                placeholder="example@domain.com..."
                                                onChange={this.onFieldChange}
                                            />
                                            <span className="field-icon"><i className="fa fa-envelope"></i></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="controls">
                                    <div className="sendit">
                                        <button
                                            type="submit"
                                            className="button btn-primary"
                                            onClick={this.onBtnClickHandler}
                                        > Reset Password
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center backer">
                                    <a
                                        href="#"
                                        className="back"
                                    onClick={this.back}
                                    >&larr;  Back</a></div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default ForgotPassword;



/** WEBPACK FOOTER **
 ** ./src/ForgotPassword.js
 **/